
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface LocationData {
  country_code?: string;
  country?: string;
  city?: string;
  loading: boolean;
  error: string | null;
}

export function useClientLocation() {
  const [locationData, setLocationData] = useState<LocationData>({
    loading: true,
    error: null
  });

  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const { data, error } = await supabase.functions.invoke('get-client-info');
        
        if (error) {
          console.error("Error fetching client location:", error);
          setLocationData({
            loading: false,
            error: "Failed to get location data"
          });
          return;
        }

        setLocationData({
          country_code: data.country_code,
          country: data.country,
          city: data.city,
          loading: false,
          error: null
        });
        
        console.log("Client location data:", data);
      } catch (err) {
        console.error("Unexpected error in location fetch:", err);
        setLocationData({
          loading: false,
          error: "An unexpected error occurred"
        });
      }
    };

    fetchLocationData();
  }, []);

  return locationData;
}
